import { render, staticRenderFns } from "./factory_detail_base_us.vue?vue&type=template&id=0f09be04&scoped=true"
import script from "./factory_detail_base_us.vue?vue&type=script&lang=js"
export * from "./factory_detail_base_us.vue?vue&type=script&lang=js"
import style0 from "./factory_detail_base_us.vue?vue&type=style&index=0&id=0f09be04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f09be04",
  null
  
)

export default component.exports